/* eslint-disable no-console */
import SvgIcon from '@png/npm-svg-icon';
import ApiManager from '../../api/crud-manager';
import utils from '../../utils';
import Incrementer from '../incrementer';
// eslint-disable-next-line import/no-cycle
import ProductFavorite from '../product-favorite'; // TODO: check no-cycle error
import RealTimePrice from '../real-time-price';
import RealTimeStock from '../real-time-stock';
import RealTimePriceStaffels from './real-time-price-staffels';

// helper functions
const triggerExternalModules = () => {
  // trigger some needed modules after data is appended
  new SvgIcon().init();
  new Incrementer().init();
  new ProductFavorite().reRenderFavorites();
  new RealTimePrice().init();
  new RealTimeStock().init();
  new RealTimePriceStaffels().init();

  // // enable rules, if real-time price and real-time stock is availa
  // eslint-disable-next-line no-undef
  cart.addEventListener();
};

window.addEventListener('triggerExternalModules', () => {
  triggerExternalModules();
});

const appendDataToElement = (data, _element) => {
  const element = _element;
  element.innerHTML = data;
};

/**
 * Class product list module
 * @class
 * @author Max Swinkels <max.swinkels@pangaea.nl>
 *
 */

class ProductList {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="ProductList"]'),
      ...options
    };
    this.apiManager = new ApiManager();
  }

  // fetch products based on item codes and generate html based on a template view
  async getProducts(itemCodes, apiTemplate) {
    const api = this.apiManager;

    // create an object with all the needed parameters
    const parameters = {
      itemcode: itemCodes, // itemCodes need to be comma-separated
      all: true, // shows the child product if the itemCode is a child product
      sort: 'unsorted', // no idea what it does
      omitfilterdata: 1, // no idea what it does
      template: apiTemplate, // indicates the name of the template file in /views/api
      items: 9999
    };

    const url = `/api/v2/catalog/product${utils.buildUrlParameters(parameters)}`;

    return api.get(url, 'text/html').then(data => data);
  }

  // call getProducts and place the html data in the placeholder
  renderProductList(_module, itemCodes, apiTemplate) {
    const module = _module;

    module.classList.add('is-loading');

    this.getProducts(itemCodes, apiTemplate)
      .then(data => {
        const placeholder =
          module.querySelector('[data-module="ProductList__placeholder"]') || module;

        module.classList.remove('is-loading');

        appendDataToElement(data, placeholder);
        triggerExternalModules();
      })
      .catch(error => {
        console.log('getProducts request failed', error);
        module.innerHTML = module.dataset.errorMessage || 'getProducts not available.';
        module.classList.remove('is-loading');
        module.classList.add('is-error');
      });
  }

  init() {
    const { moduleList } = this.config;

    moduleList.forEach(module => {
      const { productItemCodes, productListTemplate } = module.dataset;

      if (!productListTemplate && !productListTemplate) return;

      this.renderProductList(module, productItemCodes, productListTemplate);
    });
  }
}

export default ProductList;
